//ResumeSection.tsx
//This component renders a section in the resume editor with a title and content.

interface ResumeSectionProps {
    title: string;
    children: React.ReactNode;
}

export function ResumeSection({ title, children }: ResumeSectionProps) {
    return (
        <div className="mt-10 pt-10">
            <div className="flex justify-center border-b mb-4 items-center">
                <h3 className="font-bold text-xl text-center mb-4">{title}</h3>
            </div>
            <div className="col-span-3">{children}</div>
        </div>
    );
}

